import React from "react";
import { Container, Image } from "react-bootstrap";
import Slider from "react-slick";
import "./Sliders.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import cow from "../../../Asset/slider/cowfactory_nobg.png";
import cop from "../../../Asset/slider/coppercoin_nobg.png";
import nob4 from "../../../Asset/slider/4_nobg.png";
import nob7 from "../../../Asset/slider/7_nobg.png";
import fin from "../../../Asset/slider/finfolio_nobg.png";
import fri from "../../../Asset/slider/friendlyforce_nobg.png";
import group from "../../../Asset/slider/Group-290513-1.png";
import lendai from "../../../Asset/slider/lendai_nobg.png";
import paid from "../../../Asset/slider/paid_nobg.png";
import parc from "../../../Asset/slider/parcelport_nobg.png";
import ship from "../../../Asset/slider/shiptime_nobg.png";
import wel from "../../../Asset/slider/welnes_nobg.png";
import wins from "../../../Asset/slider/winstone_nobg.png";
import wish from "../../../Asset/slider/wishtime_nobg.png";
import phonePe from "../../../Asset/slider/phonepe.png";
import razorpay from "../../../Asset/slider/razorpay.png";
import Shopify from "../../../Asset/slider/Shopify.svg";
import stripe from "../../../Asset/slider/stripe.png";

const companyLogos = [
  cow,
  cop,
  nob4,
  fin,
  nob7,
  fri,
  group,
  lendai,
  paid,
  parc,
  ship,
  wel,
  wins,
  wish,
  phonePe,
  razorpay,
  Shopify,
  stripe,
];

function Sliders() {
  const settings = {
    infinite: true,
    slidesToShow: 6,
    slidesToScroll: 1,
    autoplay: true,
    speed: 3000,
    autoplaySpeed: 100,
    cssEase: "linear",
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <section className="second-section trusted-company">
      <Container>
        <div className="right-line">
          <h2 className="trusted-text">
            TRUSTED BY <span>COMPANIES WORLDWIDE</span>
          </h2>
        </div>
        <div className="slider-container first-carousal">
          <Slider {...settings} className="slider-main">
            {companyLogos.map((logo, index) => (
              <div key={index}>
                <Image
                  className="w-100 px-3"
                  src={logo}
                  alt={`Company logo ${index + 1}`}
                />
              </div>
            ))}
          </Slider>
        </div>
      </Container>
    </section>
  );
}

export default Sliders;
